<template>
<div class="chapter">
<div class="inner_page">
<div class="_idgenobjectstyleoverride" id="_idContainer1347">
<p class="structure-bnxt1" id="calibre_pb_32"><span class="bold1"> </span></p>
<p class="body_heading"><span class="bold2">Clean Fifteen</span></p>
<p class="icon"> </p>
<p class="body_numbers"><span class="bold3">1.</span>Avocados</p>
<p class="body_numbers"><span class="bold3">2.</span><span>Pineapples</span></p>
<p class="body_numbers"><span class="bold3">3.</span>Frozen <span>sweet</span><span> </span><span>peas</span></p>
<p class="body_numbers"><span class="bold3">4.</span>Onions</p>
<p class="body_numbers"><span class="bold3">5.</span>Papayas</p>
<p class="body_numbers"><span class="bold3">6.</span>Eggplants</p>
<p class="body_numbers"><span class="bold3">7.</span>Asparagus</p>
<p class="body_numbers"><span class="bold3">8.</span>Kiwis</p>
<p class="body_numbers"><span class="bold3">9.</span>Mangos</p>
<p class="body_numbers"><span class="bold3">10.</span>Cabbages</p>
<p class="body_numbers"><span class="bold3">11.</span>C<span>auliflower</span></p>
<p class="body_numbers"><span class="bold3">12.</span>C<span>antaloupes</span></p>
<p class="body_numbers"><span class="bold3">13.</span>Broccoli</p>
<p class="body_numbers"><span class="bold3">14.</span>Mushrooms</p>
<p class="body_numbers1" id="calibre_pb_33"><span class="bold3">15.</span>Honey<span>dew</span><span> </span><span>melons</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 5Ingredient_split_018.vue?089e4012